/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Auth_TitleInputs */

const he_notifications_auth_title = /** @type {(inputs: Notifications_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברות נדרשת להתראות`)
};

const en_notifications_auth_title = /** @type {(inputs: Notifications_Auth_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in for notifications`)
};

/**
* | output |
* | --- |
* | "Sign in for notifications" |
*
* @param {Notifications_Auth_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_auth_title = /** @type {((inputs?: Notifications_Auth_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Auth_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_auth_title(inputs)
	return en_notifications_auth_title(inputs)
});